import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/dto.js';
import { LegacyOrderHook } from '../legacy-order-hook.js';
import { OrderSideEffectType } from './order-side-effect-type.js';
import { OrderSideEffect } from './order-side-effect.js';

export class GenerateProductPdfSideEffect extends OrderSideEffect {
  static readonly TYPE_ID: string = '059081bb153c4a7587c73ae2bc6dda32';

  public readonly effectType: OrderSideEffectType = OrderSideEffectType.GenerateProductPdf;

  private constructor() {
    super();
  }

  get $typeId(): string {
    return GenerateProductPdfSideEffect.TYPE_ID;
  }

  static create(): GenerateProductPdfSideEffect {
    return new GenerateProductPdfSideEffect();
  }

  static fromMap(context: SerializationContext, map: SerializedData): GenerateProductPdfSideEffect {
    return new GenerateProductPdfSideEffect();
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'effectType': fromEnumAsString(this.effectType),
    };
  }

  clone(): this {
    return new GenerateProductPdfSideEffect() as this;
  }

  isSame(other: GenerateProductPdfSideEffect): boolean {
    if(this === other) {
      return true;
    }

    return other.effectType === this.effectType;
  }

  toLegacyOrderHook(): LegacyOrderHook | null {
    return null;
  }

  static verifyType(order: DataModel): boolean {
    return order instanceof GenerateProductPdfSideEffect;
  }

  static assertType(order: DataModel): order is GenerateProductPdfSideEffect {
    return order instanceof GenerateProductPdfSideEffect;
  }
}

export class GenerateProductPdfSideEffectBuilder extends DataModelBuilder<GenerateProductPdfSideEffect> {
  build(context: SerializationContext, map: SerializedData): GenerateProductPdfSideEffect {
    return GenerateProductPdfSideEffect.fromMap(context, map);
  }
}
